export const ValidityPeriodIconEnum = {
    HISTORY: "historyImage",
    INFINITE: "infiniteImage",
};
